import { SparklesIcon } from "@heroicons/react/24/outline";
import { useAppContext } from "../../context/AppContext";
import { useUser } from "../../hooks/useUsers";
import { Button } from "../Button";
import BaseModal from "./BaseModal";
import PremiumUpsellModal from "./PremiumUpsellModal";

type PaymentModalProps = {
    // Empty type for future extensibility
}

export default function PaymentModal({ }: PaymentModalProps) {
    const { paymentModal, setPaymentModal } = useAppContext();
    const { data: user } = useUser();
    const isOsd = user?.plan && user?.plan === "OSD";

    return (!isOsd ? <PremiumUpsellModal
        open={paymentModal}
        onClose={() => setPaymentModal(false)}
    /> :
        <BaseModal open={paymentModal} onClose={() => setPaymentModal(false)}>
            <div className="flex w-full flex-col">
                {isOsd ? (
                    <div className="text-center">
                        <div className="flex justify-center mb-4">
                            <SparklesIcon className="h-12 w-12 text-blue-600" />
                        </div>
                        <h3 className="text-primary font-primary text-center mb-2">Desbloqueie benefícios exclusivos</h3>
                        <p className="text-text font-text text-thirdText mb-6">
                            O recurso que você está tentando acessar não está incluso em sua assinatura.
                            Entre em contato com nosso time para consultar como alterar seu plano.
                        </p>
                        <Button
                            className="w-full py-3 bg-blue-600 hover:bg-blue-700 mb-2"
                            onClick={() => window.open("https://wa.me/5511993581886?text=Ol%C3%A1,%20gostaria%20de%20alterar%20meu%20plano", "_blank")}
                            title="Fale conosco no WhatsApp"
                        />
                    </div>
                ) : (
                    <></>
                )}

                <Button
                    className="mt-2 text-xs font-text text-gray-500 bg-transparent hover:bg-gray-50 hover:text-gray-700"
                    title="Fechar"
                    onClick={() => setPaymentModal(false)}
                />
            </div>
        </BaseModal>
    );
}
